/* RESPONSIBLE TEAM: team-inbox-experience */
import Model, { attr, belongsTo } from '@ember-data/model';
import type Role from '../role';
import { type SidebarSectionWireFormat } from 'embercom/objects/inbox/sidebar-section';

export type ObjectType = 'sidebar_section';

export default class RoleComponent extends Model {
  @belongsTo('role', { async: false }) declare role: Role;
  @attr('string') declare componentType: ObjectType;
  @attr() declare configuration: SidebarSectionWireFormat[];
  @attr('boolean') declare enforced: boolean;
  @attr('date') declare enforcedAt: Date | null;
  @attr('boolean') declare allowAdminReorder: boolean;
  @attr('boolean') declare allowAdminPinUnpin: boolean;
}
